import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { ProductoService } from '../../_services/producto.service';
import { forkJoin, Observable } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { SegmentoActivo } from '../../_models/segmento-activo';
import { SegmentoActivoService } from '../../_services/segmento-activo.service';
import {PaqueteSeguros} from '../../_models/paquete-seguros';
import {SegmentoIngreso} from '../../_models/segmento-ingreso';

@Component( {
  templateUrl: 'segmento-activos.component.html',
  selector: 'app-segmento-activos',
  providers: [ ConfirmationService ]
} )
export class SegmentoActivosComponent implements OnInit {
  @Input() detalle: boolean = false;
  columnas: any[];
  formulario: FormGroup;
  carSegmentoProducto: boolean;
  segmentoActivos: SegmentoActivo[] = [];
  @Input()
  segmento: Segmento;
  @Input()
  segmentoTemp: any;
  submitted: boolean;
  guardando: boolean;
  rangoDesdeValido = true;
  rangoInvalido = false;
  allActivos: ListaItem[];
  edit = false;
  cargando = true;

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private segmentoActivoService: SegmentoActivoService,
               private productosService: ProductoService,
               private listaService: ListaService,
               private confirmacionServicio: ConfirmationService ) {
  }


  ngOnInit(): void {
    this.formulario = this.formBuilder.group( {
      idSegmentoActivo: [ null ],
      nombreRango: [ null, [ Validators.required ] ],
      rangoDesde: [ null, [ Validators.required ] ],
      rangoHasta: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );

    this.columnas = [
      { field: 'nombreRango', header: this.navServicio.buscarMensaje( 'SEGMENTOSACTIVOS.LBL_NOMBRERANGO' ), sort: true },
      { field: 'rangoDesde', header: this.navServicio.buscarMensaje( 'SEGMENTOSACTIVOS.LBL_RANGODESDE' ), sort: true },
      { field: 'rangoHasta', header: this.navServicio.buscarMensaje( 'SEGMENTOSACTIVOS.LBL_RANGOHASTA' ), sort: true },
    ];
    if ( !this.detalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }

    forkJoin( this.segmentoActivoService.obtenerPorSegmento( this.segmento.idSegmento ) ).subscribe( ( [  res2 ] ) => {
      this.segmentoActivos = res2;
      this.cargando = false;

    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );


  }

  get f() {
    return this.formulario.controls;
  }

  get segActivos() {

    this.segmentoActivos.sort(function (a, b) {
      if (a.rangoDesde > b.rangoDesde) {
        return 1;
      }
      if (a.rangoDesde < b.rangoDesde) {
        return -1;
      }
      return 0;
    });
    return this.segmentoActivos.filter( s => s.indicadorHabilitado );
  }

  onSubmit(): void {
    this.submitted = true;
    this.rangoInvalido = this.validarRango();
    if ( this.formulario.valid && this.rangoInvalido) {
      this.carSegmentoProducto = true;
      const temp: SegmentoActivo = this.formulario.value;
      temp.idSegmento = this.segmento.idSegmento;
      const a = this.segmentoActivos.find( sp => sp.idSegmentoActivo
        === temp.idSegmentoActivo );
      if ( a ) {
        temp.idSegmentoActivo = a.idSegmentoActivo;
      }
      temp.indicadorHabilitado = true;
      if ( temp.idSegmentoActivo ) {
        this.segmentoActivoService.actualizar( temp ).subscribe( res => {
          const tempSegmentoP: SegmentoActivo[] = this.segmentoActivos;
          this.segmentoActivos = [];
          tempSegmentoP.map( t => {
            if ( t.idSegmentoActivo === temp.idSegmentoActivo ) {
              t = temp;
            }
            this.segmentoActivos.push( t );
          } );
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.edit = false;
          this.navServicio.setMesage( 2 );
        } );
      } else {
        this.segmentoActivoService.agregar( temp ).subscribe( res => {
          temp.idSegmentoActivo = res.idSegmentoActivo;
          this.segmentoActivos.push( temp );
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
          this.navServicio.setMesage( 1 );
        } );
      }
    } else {
      return;
    }
  }

  disable( row: SegmentoActivo ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Activos',
      icon: 'fa fa-question-circle',
      key: 'activos',
      accept: () => {
        row.indicadorHabilitado = false;
        this.segmentoActivoService.actualizar( row ).subscribe( res => {
          const temp: SegmentoActivo[] = this.segmentoActivos;
          this.formulario.reset();
          this.submitted = false;
          this.edit = false;
          this.segmentoActivos = [];
          temp.map( t => {
            if ( t.idSegmentoActivo === row.idSegmentoActivo ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.segmentoActivos = temp;
        } );
      }
    } );

  }

  validarValor( event: any, desde: boolean ) {
    const rangoDesde = this.formulario.controls.rangoDesde.value;
    const rangoHasta = this.formulario.controls.rangoHasta.value;
    if ( desde && rangoHasta ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    } else if ( !desde && rangoDesde ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    }
  }

  validarRango(): boolean {
    const rangoDesde = Number( this.f.rangoDesde.value );
    const rangoHasta = Number( this.f.rangoHasta.value );
    const idSegmentoActivo = this.f.idSegmentoActivo.value;
    const dato1 = this.segmentoActivos.find( x => x.rangoDesde <= Number( rangoDesde ) && x.rangoHasta > Number( rangoDesde ) && x.indicadorHabilitado);
    const dato2 = this.segmentoActivos.find( x => x.rangoDesde < Number( rangoHasta ) && x.rangoHasta >= Number( rangoHasta ) && x.indicadorHabilitado);
    let validacion = true;
    if ( (dato1 && dato1.idSegmentoActivo !== idSegmentoActivo && dato1.indicadorHabilitado)
      || (dato2 && dato2.idSegmentoActivo !== idSegmentoActivo && dato2.indicadorHabilitado) ) {
      validacion = false;
    } else {
      this.segmentoActivos.map( ( s: SegmentoActivo ) => {
        if(s.indicadorHabilitado){
          let datoMin = Number(s.rangoDesde);
          let datohas = Number(s.rangoHasta);
          if(rangoDesde > datoMin  && rangoDesde < datohas ){
            if(s.idSegmentoActivo !== idSegmentoActivo){
              validacion = false;
            }
          }
          if( rangoHasta > datoMin && rangoHasta < datohas ){
            if(s.idSegmentoActivo !== idSegmentoActivo){
              validacion = false;
            }
          }
          if( datoMin > rangoDesde && datoMin < rangoHasta ){
              validacion = false;
          }
        }
      } );
    }
    return validacion;
  }

  editar( row: SegmentoActivo ): void {
    this.edit = true;
    this.submitted = false;
    this.formulario = this.formBuilder.group( {
      idSegmentoActivo: [ row.idSegmentoActivo ? row.idSegmentoActivo : null],
      nombreRango: [ row.nombreRango ? row.nombreRango : null, [ Validators.required ] ],
      rangoDesde: [ (row.rangoDesde !== null && row.rangoDesde !== undefined) ? row.rangoDesde : null, [ Validators.required ] ],
      rangoHasta: [ (row.rangoHasta !== null && row.rangoHasta !== undefined) ? row.rangoHasta : null, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );

  }


}

